
import * as types from '../mutation-types';
import { get_languages } from '@/api/lang';

export const state = {
  locale: 'en',
  locales: [],
  lang_name: 'english',
  loading: false,
}

export const getters = {
  loading: state => state.loading,
  locale: state => state.locale,
  locales: state => state.locales,
  lang_name: state => state.lang_name
}
export const mutations = {
  [types.SET_LOCALE](state, payload) {
    state.locale = payload.code
    state.lang_name = payload.name;
  },
  [types.LANGUAGES](state, payload) {
    state.loading = true
  }
  ,
  [types.LANGUAGES_FAIL](state, payload) {
    state.locales = [];
    state.loading = false;

  }
  ,
  [types.LANGUAGES_SUCCESS](state, payload) {
    state.locales = payload;
    state.loading = false;
  }
}
export const actions = {
  setLocale({ commit }, payload) {
    commit(types.SET_LOCALE, payload)
  },
  async fetchLangs({ commit }, payload) {
    commit(types.LANGUAGES);
    try {
      let data = await get_languages();
      commit(types.LANGUAGES_SUCCESS, data)
    } catch (error) {
      commit(types.LANGUAGES_FAIL, error)
    }
  }
}
